import { CartCategory, Product, ProductImageType, ProductType } from '../../context/CartContext';
import cannedSodaImage from '../../assets/images/storefront/product_storefront_canned_soda.svg';
import chipsImage from '../../assets/images/storefront/product_storefront_chips.svg';
import energyDrinkImage from '../../assets/images/storefront/product_storefront_energy_drink.svg';
import takisImage from '../../assets/images/storefront/product_storefront_takis.svg';

export const storeFrontProducts: Product[] = [
  {
    id: '7000',
    name: 'Canned Soda',
    price: 2,
    wholesale_price: 1,
    height_inches: 4.8,
    width_inches: 2.6,
    depth_inches: 2.6,
    images: [
      { image_path: cannedSodaImage, image_type: ProductImageType.DETAIL },
      { image_path: cannedSodaImage, image_type: ProductImageType.SMALL },
      { image_path: cannedSodaImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 370,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Drinks',
    sub_category: 'Soda',
    description: 'A cold canned soda.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7001',
    name: 'Chips',
    price: 2,
    wholesale_price: 1,
    height_inches: 8,
    width_inches: 5,
    depth_inches: 2,
    images: [
      { image_path: chipsImage, image_type: ProductImageType.DETAIL },
      { image_path: chipsImage, image_type: ProductImageType.SMALL },
      { image_path: chipsImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 50,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Snacks',
    sub_category: 'Chips',
    description: 'A single bag of chips.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7002',
    name: 'Energy Drink',
    price: 3,
    wholesale_price: 2,
    height_inches: 6.2,
    width_inches: 2.4,
    depth_inches: 2.4,
    images: [
      { image_path: energyDrinkImage, image_type: ProductImageType.DETAIL },
      { image_path: energyDrinkImage, image_type: ProductImageType.SMALL },
      { image_path: energyDrinkImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 475,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Drinks',
    sub_category: 'Energy Drinks',
    description: 'A chilled energy drink.',
    is_customizeable: false,
    enabled: true
  },
  {
    id: '7003',
    name: 'Takis',
    price: 1,
    wholesale_price: 0.5,
    height_inches: 7,
    width_inches: 4.5,
    depth_inches: 1.5,
    images: [
      { image_path: takisImage, image_type: ProductImageType.DETAIL },
      { image_path: takisImage, image_type: ProductImageType.SMALL },
      { image_path: takisImage, image_type: ProductImageType.LARGE }
    ],
    weight_grams: 45,
    product_type: ProductType.StoreFront,
    cart_category: CartCategory.LOCAL_PICKUP_ONLY,
    category: 'Snacks',
    sub_category: 'Takis',
    description: 'A single bag of Takis.',
    is_customizeable: false,
    enabled: true
  }
];
